
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'destinatario',
        label: 'Destinatário',
        info: 'Para enviar mais de um destinatário, por favor separe os emails com `;` (ponto e vírgula)',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/esocial/lotes/_form/lote-email-cadastro.js